import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

export interface TeamMember {
  user_id: string; display_name: string; display_role: string; role: string;
  joined_at: string; visibility_tier: string;
  recent_topics: string[]; tools_used: string[];
  last_active?: string | null;
  skills?: Array<{ name: string; frequency: number }> | null;
  projects?: Array<{ name: string; topic_count: number }> | null;
  current_focus?: string[] | null;
  conversation_stats?: { total_conversations: number; total_tokens: number; first_captured_at?: string | null; last_captured_at?: string | null } | null;
}

export interface TeamMembersSurfaceData { members: TeamMember[] }

export function useTeamMembersSurface() {
  const query = useQuery({
    queryKey: ['surfaces', 'team-members'],
    queryFn: () => apiFetch<TeamMembersSurfaceData>('/api/surfaces/team/members'),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
  return { ...query, data: query.data ?? undefined };
}
